import { PropsWithChildren, ReactNode, useState } from "react";

import { styled } from "@mui/material/styles";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps, accordionSummaryClasses } from "@mui/material/AccordionSummary";

import ArrowRightIcon from "@assets/arrow_right.svg";

interface CustomAccordionProps extends PropsWithChildren {
    title: ReactNode;
    defaultExpanded?: boolean;
}

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
    () => ({
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&::before": {
            display: "none",
        },
    }),
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary expandIcon={<img src={ArrowRightIcon} />} {...props} />
))(({ theme }) => ({
    flexDirection: "row-reverse",
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
        transform: "rotate(90deg)",
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
}));

export const CustomAccordion = (props: CustomAccordionProps) => {
    // const [expanded, setExpanded] = useState<boolean>(props.expanded ?? false);

    // const handleAccordionToggle = () => {
    //     setExpanded((prev) => !prev);
    // };

    return (
        <Accordion
            defaultExpanded={props.defaultExpanded}
            // onChange={handleAccordionToggle}
            slotProps={{ transition: { unmountOnExit: true } }}
        >
            <AccordionSummary>{props.title}</AccordionSummary>
            <AccordionDetails>{props.children}</AccordionDetails>
        </Accordion>
    );
};
